export default __webpack_public_path__ + "../images/partners-logo-3.png";